export interface Apikeys {
  status: string;
  google_oauth_client_id?: string;
  google_oauth_client_secret?: string;
  google_oauth_ios_client_id?: string;
  /** Apple Services ID (Sign in with Apple web client_id). */
  apple_client_id?: string;
  apple_redirect_uri?: string;
  /** Microsoft Entra ID Application (client) ID (Sign in with Microsoft). */
  microsoft_client_id?: string;
  stripe_pk_test?: string;
  stripe_pk_live?: string;
  gtag_config?: string;
  local_gtag_config?: string;
  /** Maps JavaScript / Places API (New) browser key. */
  google_maps_api_key?: string;
  sound_api_reg_key?: string;
  cloudflare_api_token?: string;
  /** Public string keys, plus JSON object blobs (e.g. fcm_google_services_json). */
  [key: string]: string | Record<string, unknown> | unknown[] | undefined;
}

export const apikeys: Apikeys = {"status":"success","stripe_pk_test":"pk_test_51SX2jX7dJOb0gIcdZlslQePSOPxCc8cexkV8FPKm4OMhD4uA6P7jnBUVtsyPhj9RfXRL1hT1HrIAZlDpR6OoA92200vRhXhlDR","stripe_pk_live":"pk_live_51SX2jX7dJOb0gIcd9Ir6M7c27EHUGOl6jJsvNLigLOqT7VdtWKdoYuTokqV4MEvjDqO7mSh4yzmCbMrKlsyKhLFb00kfwYW87y","google_oauth_client_id":"1008153160858-jbiimk8hk9ch1f30rvpmin6tqolj0h8r.apps.googleusercontent.com","google_maps_api_key":"AIzaSyBgCZl52ME-7c35aMNs4f6cHPz2GoZ2BZU","google_photos_environment":"development","cloudflare_environment":"test","namecheap_environment":"sandbox","preferred_registrar":"cloudflare","etransfer_imap_host":"imap.gmail.com"};
